import React from 'react'
import MediaQuery from 'react-responsive'
import WebFont from 'webfontloader'
import Helmet from 'react-helmet'

// Components
import Fractals from '../components/fractals/index'
import Button from '../components/button'
import Header from '../components/header'
import Divider from '../components/divider'

// Assets
import favicon from '../assets/favicon-512x512.png'

class IndexPage extends React.Component {
  detectBrowserLanguage() {
    return navigator.language || navigator.userLanguage
  }

  componentWillMount() {
    if (typeof window !== `undefined`) {
      var lang = localStorage.getItem('setLang')

      if (lang === 'en') {
        window.location = '/en'
      } else if (lang === 'cs') {
        return
      } else if (this.detectBrowserLanguage() !== 'cs') {
        window.location = '/en'
      }

      WebFont.load({
        google: {
          families: ['Catamaran:400,800', 'Teko:500', 'sans-serif'],
        },
      })
    }
  }

  render() {
    return (
      <div>
        <Helmet
          title="Distributa.io"
          meta={[
            {
              name: 'description',
              content: 'Zabýváme se návrhem a implementací řešení pro komplexní algoritmické problémy. Složitou úlohu bereme jako výzvu, kterou přetavíme v použitelný produkt.',
            },
            {
              name: 'keywords',
              content: 'Problém obchodního cestujícího, big data, distribuované databáze, Cassandra, Scylla, NoSQL, TSP, Traveling Salesman Problem, C++, Haskel',
            },
            {
              name: 'google-site-verification',
              content: 'DwylpeeQdj3QgkL1HK1yvo1v2_jihwmLAuiiHsqpDIw',
            },
          ]}
          link={[
            {
              rel: 'shortcut icon',
              type: 'image/png',
              href: favicon,
            },
          ]}
        >
          <html lang="cs" />
        </Helmet>

        <Header
          siteTitle="Distributa.io"
          links={[
            { link: 'uvod', label: 'Úvod', active: true },
            { link: 'kontakt', label: 'Kontakt' },
          ]}
        />

        <div className="hp">
          {/* Hero Section */}
          <header id="uvod" className="hero flex flex-v-center pr oh">
            <div className="cont flex">
              <div className="half">
                <h1>Řešíme matematické a&nbsp;informatické problémy</h1>
                <p className="fs20 mb55">
                  Naše schopnosti a zkušenosti pomáhají tam, kde váš tým tápe
                </p>
                <Button link="kontakt" className="mr20 m-mr0 mb15">
                  KONTAKTUJTE NÁS
                </Button>
              </div>
              <div className="half">
                <MediaQuery query="(min-width: 770px)">
                  <Fractals />
                </MediaQuery>
              </div>
            </div>
          </header>

          <Divider />

          {/* Contact Section */}
          <div id="kontakt" className="cont kontakt pt150 m-pt30 pb140 mb30">
            <div className="flex">
              <div className="half">
                <h2>Kontakt</h2>
                <p className="mb30 fs18">
                  Máte zájem o naše služby? Potřebujete vědět více informací?{' '}
                  <br />
                  Napište nám o svém projektu, se kterým vám můžeme pomoci.
                  Těšíme se na nové výzvy.
                </p>
              </div>
            </div>
            <div className="flex">
              <div className="mr40">
                <div className="bold fs12 upper c-main">Distributa</div>
                <a href="mailto:info@distributa.io" className="teko fs36">
                  info@distributa.io
                </a>
              </div>
            </div>
          </div>

          {/* Business Info */}
          <div className="cont business-info">
            <div className="fs14 p15">
              Distributa.io s.r.o., Pražákova 1008/69, Štýřice, 639 00 Brno,
              IČ 07238657, Spisová značka: C 107064 vedená u Krajského soudu v
              Brně
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js